<form
  novalidate
  class="form-master-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit($event)"
>
  <ng-content></ng-content>

  <button *ngIf="!preventSubmitOnEnter" type="submit" class="sr-text">
    Submit
  </button>
</form>
